import script from "./ResourceBoardView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourceBoardView.vue?vue&type=script&setup=true&lang=ts"

import "./ResourceBoardView.vue?vue&type=style&index=0&id=46f04183&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46f04183"]])

export default __exports__